"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsZoomInteracting = useIsZoomInteracting;
var _internals = require("@mui/x-charts/internals");
var _useChartProZoom = require("../../internals/plugins/useChartProZoom");
/**
 * Get access to the zoom state.
 *
 * @returns {boolean} Inform the zoom is interacting.
 */
function useIsZoomInteracting() {
  const store = (0, _internals.useStore)();
  const isInteracting = (0, _internals.useSelector)(store, _useChartProZoom.selectorChartZoomIsInteracting);
  return isInteracting;
}